import React from 'react';
import {
	type RegisterCommandsProps,
	RegisterCommandsWithRegistry,
} from '@atlassian/jira-command-palette';

import type { COMMAND_PALETTE_REGISTRY_ID } from '../../common/constants/registry';

export const RegisterCommands = (props: RegisterCommandsProps<COMMAND_PALETTE_REGISTRY_ID>) => (
	<RegisterCommandsWithRegistry<COMMAND_PALETTE_REGISTRY_ID> {...props} />
);
